(function () {
  'use strict';

  var FIELDS =
    'title,product_type,vendor,variants.title,tag,variants.sku,body';

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function closestSearchbox(el) {
    if (!el) return null;
    return el.closest('.searchbox') || el.closest('doorware-predictive-search');
  }

  class DoorwarePredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form[action*="search"]') || this.querySelector('form');
      this.input = this.querySelector('input[name="q"]');
      this.panel = this.querySelector('[data-dw-predictive-panel]');
      this.sectionId = this.dataset.sectionId || 'predictive-search';
      this.urlBase = (this.dataset.url || '/search/suggest').replace(/\/?$/, '');
      this.minChars = parseInt(this.dataset.minChars || '2', 10);
      if (!this.form || !this.input || !this.panel) return;

      this.abortController = null;
      this.debouncedSearch = debounce(this.runSearch.bind(this), 300);

      this.panelId = 'dw-ps-' + Math.random().toString(36).slice(2, 11);
      this.panel.id = this.panelId;
      this.input.setAttribute('role', 'combobox');
      this.input.setAttribute('aria-autocomplete', 'list');
      this.input.setAttribute('aria-expanded', 'false');
      this.input.setAttribute('aria-controls', this.panelId);
      this.input.setAttribute('aria-haspopup', 'listbox');

      this._onInput = this._onInput.bind(this);
      this._onFocus = this._onFocus.bind(this);
      this._onDocClick = this._onDocClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);

      this.input.addEventListener('input', this._onInput);
      this.input.addEventListener('focus', this._onFocus);
      document.addEventListener('click', this._onDocClick);
      this.input.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      if (!this.input) return;
      this.input.removeEventListener('input', this._onInput);
      this.input.removeEventListener('focus', this._onFocus);
      document.removeEventListener('click', this._onDocClick);
      this.input.removeEventListener('keydown', this._onKeydown);
    }

    _onInput() {
      this.debouncedSearch();
    }

    _onFocus() {
      this.debouncedSearch();
    }

    _onDocClick(e) {
      if (!this.contains(e.target)) this.close();
    }

    _onKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
        this.input.blur();
      }
    }

    close() {
      this.panel.hidden = true;
      this.panel.innerHTML = '';
      this.input.setAttribute('aria-expanded', 'false');
      var box = closestSearchbox(this);
      if (box) box.classList.remove('s-loading');
    }

    runSearch() {
      var term = (this.input.value || '').trim();
      if (term.length < this.minChars) {
        this.close();
        return;
      }

      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      var box = closestSearchbox(this);
      if (box) box.classList.add('s-loading');

      var params = new URLSearchParams();
      params.set('q', term);
      params.set('section_id', this.sectionId);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '8');
      params.set('resources[limit_scope]', 'all');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', FIELDS);

      var sep = this.urlBase.indexOf('?') >= 0 ? '&' : '?';
      var url = this.urlBase + sep + params.toString();

      fetch(url, { signal: this.abortController.signal, credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
          return res.text();
        })
        .then(
          function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var sec = doc.querySelector('#shopify-section-predictive-search');
            var inner = sec ? sec.innerHTML : '';
            this.panel.innerHTML = inner;
            this.panel.hidden = !inner;
            this.input.setAttribute('aria-expanded', inner ? 'true' : 'false');
            if (box) box.classList.remove('s-loading');
          }.bind(this)
        )
        .catch(
          function (err) {
            if (err && err.name === 'AbortError') return;
            this.close();
          }.bind(this)
        );
    }
  }

  if (!customElements.get('doorware-predictive-search')) {
    customElements.define('doorware-predictive-search', DoorwarePredictiveSearch);
  }
})();
